import Big from 'big.js';
import moment from 'dayjs';
import { parseJson } from './utils';

/**
 * 存储token
 * @param token token信息
 */
export function clearToken() {
  localStorage.removeItem('token');
}

/**
 * 存储token
 * @param token token信息
 */
export function setToken({ token }: { token: string }) {
  localStorage.setItem('token', token);
}

/**
 * 设置权限
 * @param powers 权限信息
 */
export function setPowers(powers: string[]) {
  return localStorage.setItem('powers', JSON.stringify(powers));
}

/**
 * 获取权限信息
 */
export function getPowers() {
  const powers = localStorage.getItem('powers') || '[]';
  return JSON.parse(powers);
}

/**
 * 获取token信息
 */
export function getToken() {
  return localStorage.getItem('token') || '';
}

export function getAuthorization() {
  return `Bearer ${getToken()}`;
}

/**
 * 获取token信息
 */
export function getTokenInfo(tokenString?: string) {
  if (!tokenString) {
    return {};
  }
  const [, payload] = tokenString.split('.') as [string, string];
  const info = Buffer.from(payload, 'base64').toString();
  return parseJson(info);
}

/**
 * 从token中获取用户id
 */
export function getUserId() {
  const tokenString = localStorage.getItem('token') || '';
  return getTokenInfo(tokenString).id;
}

/**
 * 判断登陆态
 */
export async function isLogin(): Promise<boolean> {
  const tokenString = localStorage.getItem('token') || '';
  const res = getTokenInfo(tokenString);
  if (
    res &&
    moment()
      .add(1, 'minute')
      .isBefore(
        Big(res.exp || 0)
          .mul(1000)
          .toNumber(),
      )
  ) {
    return true;
  }
  return false;
}
